import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  search: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: '1px solid #B3B3B3',
    height: 40,
    width: '600px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media all and (max-width: 1390px)': {
      width: '450px'
    },
    '@media all and (max-width: 1260px)': {
      width: '300px'
    },
    '@media all and (max-width: 479px)': {
      width: '100%'
    }
  },
  inputField: {
    color: '#263057',
    width: '600px',
    fontSize: '14px',
    lineHeight: '18.75px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingLeft: 10,
    paddingRight: 10,
    '@media all and (max-width: 1390px)': {
      width: '450px'
    },
    '@media all and (max-width: 1260px)': {
      width: '300px'
    },
    '@media all and (max-width: 479px)': {
      width: '100%'
    }
  },
  text: {
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#263057',
    textTransform: 'none',
    fontSize: 14,
    marginLeft: 10,
    marginRight: 5,
    '@media all and (min-width: 480px) and (max-width: 767px)': {
      display: 'none'
    },
    '@media all and (max-width: 479px)': {
      display: 'none'
    }
  },
  cancelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  icon: {
    color: '#00A88F'
  },
  btn: {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))

export default useStyles
